module.exports = __webpack_public_path__ + "img/methods (4).bcbbeb3a.png";